import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/academy-benner.jpg'
import _imports_1 from '../images/academy-benner-mobile.jpg'


const _withScopeId = n => (_pushScopeId("data-v-2704d9cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background":"#f0f0f0"} }
const _hoisted_2 = { class: "banner-wrapper relative" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "banner d-none d-md-block"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "banner d-md-none"
}, null, -1))
const _hoisted_5 = { class: "navbar-wrapper" }

import { ref, onMounted, computed } from 'vue';
  import { request } from '@/utils';
  import { IEmartProgram } from '@/templates/emart/type';
  import { useRoute, useRouter } from 'vue-router';
  import Tab1 from './components/tab-1.vue';
  import Tab2 from './components/tab-2.vue';
  import Tab3 from './components/tab-3.vue';
  import Tab4 from './components/tab-4.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const tabs = ['01', '02', '03', '04'];

  const route = useRoute();
  const router = useRouter();
  const program = ref<IEmartProgram>();
  const tabName = computed(() => {
    return tabs[Number(route.query.tab)];
  });

  onMounted(async () => {
    if (!tabName.value) {
      // 强制跳转到tab0 防止 next button 出问题
      router.replace({ query: { ...route.query, tab: 0 } });
    }
    const { data } = await request.get(`/programs/${route.params.id}`);
    program.value = data;
  });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (item, index) => {
          return _createVNode(_component_router_link, {
            key: index,
            to: {query: { tab: index }},
            class: _normalizeClass(["item", { active: _unref(tabName) === item }]),
            replace: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(item), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"])
        }), 64))
      ])
    ]),
    (_unref(tabName) === tabs[0])
      ? (_openBlock(), _createBlock(Tab1, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(tabName) === tabs[1])
      ? (_openBlock(), _createBlock(Tab2, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(tabName) === tabs[2])
      ? (_openBlock(), _createBlock(Tab3, { key: 2 }))
      : _createCommentVNode("", true),
    (_unref(tabName) === tabs[3])
      ? (_openBlock(), _createBlock(Tab4, {
          key: 3,
          program: (program.value as IEmartProgram)
        }, null, 8, ["program"]))
      : _createCommentVNode("", true)
  ]))
}
}

})